// Sent to the model as the tool description: when to call generateDiagram.
export const WHEN_TO_USE = `Re-lay-out the diagram in the Assistant Diagram view the user
is looking at. Call this when the user asks to visualize, diagram, map out, or lay
out the graph they are currently viewing — e.g. "show this as an organic graph",
"lay it out top-to-bottom", "use a tree layout". You do not place nodes or compute
positions — the frontend already holds the in-view graph and lays it out itself
using the recipe. Pass the recipe's fields — \`title\`, \`layout\`, and \`showLegend\` —
as the top-level arguments of the call, conforming to the payload schema. Include all
of them, and do NOT nest them under a \`payload\` key (call with \`{ "layout": … }\`,
not \`{ "payload": { "layout": … } }\`).`;

export const DIAGRAM_CONTEXT_DESCRIPTION = `The context provides 'componentTypes' — the
distinct component type names currently visible in the view. Use them to write a
fitting title for the diagram. When the user does not specify a layout, default to
a hierarchical layout with the legend on.`;
